module.exports = __webpack_public_path__ + "img/1e57d69.jpg";